import React, { useEffect, useState } from "react";
import AdminReviewLeavs from "./adminReviewLeavs";
import ReviewRegularization from "./adminReviewRegularization";
import ReviewTimesheets from "./adminReviewTimesheets";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetDashBoardReviewsQuery } from "../../api/allReviewsAPI";
import { setDashBoardReviewData } from "../../store/reducers/dashboardReviewsSlice";

const ReviewPage = () => {
  const [reViewNav, setReviewNav] = useState("timesheets");
  const dispatch = useDispatch();
  const dashBoardReviewData = useSelector((state) => state.dashBoardReview);
  const [getDashBoarReviewdata, { data: fetchedDashboardData }] =
    useLazyGetDashBoardReviewsQuery({});
  const changeReviewNaw = (evnt) => {
    setReviewNav(evnt.target.id);
  };

  const showContent = () => {
    if (reViewNav === "leaves") {
      return <AdminReviewLeavs />;
    } else if (reViewNav === "timesheets") {
      return <ReviewTimesheets />;
    } else if (reViewNav === "regularization") {
      return <ReviewRegularization />;
    }
  };
  useEffect(() => {
    if (fetchedDashboardData?.data) {
      dispatch(setDashBoardReviewData(fetchedDashboardData?.data));
    }
  }, [fetchedDashboardData]);
  useEffect(() => {
    getDashBoarReviewdata();
  }, [dashBoardReviewData]);
  return (
    <div className="grid grid-cols-[15%_85%] font-medium text-xl">
      <div className="bg-blue-100 pt-[25%] flex flex-col items-start font-medium">
        <div
          className={`${
            reViewNav === "timesheets" ? "bg-blue-400" : "hover:bg-blue-200"
          } p-5 w-full cursor-pointer`}
          id="timesheets"
          onClick={(e) => changeReviewNaw(e)}
        >
          Timesheets
        </div>
        <div
          className={`${
            reViewNav === "leaves" ? "bg-blue-400" : "hover:bg-blue-200"
          } p-5 w-full cursor-pointer`}
          id="leaves"
          onClick={(e) => changeReviewNaw(e)}
        >
          Leaves
        </div>
        <div
          className={`${
            reViewNav === "regularization" ? "bg-blue-400" : "hover:bg-blue-200"
          } p-5 w-full cursor-pointer`}
          id="regularization"
          onClick={(e) => changeReviewNaw(e)}
        >
          Regularization
        </div>
      </div>
      <div className="h-screen p-[3%] pt-[5%] shadow-2xl overflow-scroll">{showContent()}</div>
    </div>
  );
};

export default ReviewPage;
